import React from 'react';
import { isBrowser } from "react-device-detect";
import { TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import globals from '../../globals';

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(Node) {
        if (!Node.titleRef || !Node.subTitleRef) {
            return;
        }

        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite();

        if (isBrowser) {
            tl.fromTo(Node.titleRef , 0.75, {x: -100, opacity: 0}, {x: 0, opacity: 1, ease: Power4.easeOut})
                .fromTo(Node.subTitleRef , 1, globals.getSubAnimation(Node.subTitleRef), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)}, 0);

            new ScrollMagic.Scene({
                triggerElement: '.supporting-trigger',
                reverse: false
            })
                .setTween(tl)
                .addTo(controller);
        }
    }
    
}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Supporting/animations.js